import { createEnv } from '@t3-oss/env-core'
import { z } from 'zod/v4'

import { sdkEnv } from '@package/sdk/env'

export function utilsEnv() {
  return createEnv({
    extends: [sdkEnv()],
    server: {
      PIN_ENCRYPTION_KEY: z.string().min(1),
    },
    clientPrefix: 'NEXT_PUBLIC',
    client: {
      NEXT_PUBLIC_SCHOOL_URL: z
        .string()
        .min(1)
        .refine((s) => new URL(s)),
      NEXT_PUBLIC_WEB_URL: z
        .string()
        .min(1)
        .refine((s) => new URL(s)),
      NEXT_PUBLIC_ACCOUNT_URL: z
        .string()
        .min(1)
        .refine((s) => new URL(s)),
      NEXT_PUBLIC_MARKETING_URL: z
        .string()
        .min(1)
        .refine((s) => new URL(s)),
      NEXT_PUBLIC_PARTNER_URL: z
        .string()
        .min(1)
        .refine((s) => new URL(s)),
      NEXT_PUBLIC_ADMIN_URL: z
        .string()
        .min(1)
        .refine((s) => new URL(s)),
      NEXT_PUBLIC_API_URL: z
        .string()
        .min(1)
        .refine((s) => new URL(s)),
      NEXT_PUBLIC_CONTENT_URL: z
        .string()
        .min(1)
        .refine((s) => new URL(s)),
    },
    runtimeEnv: process.env,
    skipValidation:
      !!process.env.CI ||
      process.env.npm_lifecycle_event === 'lint' ||
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      typeof (globalThis as any).window !== 'undefined', // Skip in browser
  })
}
